// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1yQW-","buttons":"PendingPaymentAlert_buttons__TDqN4"};